// Central content + config for MSM Unify BBSR (MSM Unify x Career Banale)

export const EXTERNAL_LINKS = {
  msmunify: "https://www.msmunify.com/",
  careerbanale: "https://careerbanale.com/",
  facebook: "https://www.facebook.com/share/18UAeUMA6j/?mibextid=wwXIfr",
  linkedin: "https://www.linkedin.com/posts/world-youth-skills-day-ugcPost-7482884480714571776-lLxd/?utm_source=share&utm_medium=member_ios&rcm=ACoAAALhWtsBJAWNFsJkdlEI1-PjfO-t2I2b9bo",
  instagram: "https://www.instagram.com/msm_unify_bbsr?igsh=cG5rNGl3cTlmbDV1",
  youtube: "https://youtube.com/@msmunify07?si=_8XDA-bqEAHplPT1",
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Ecosystem", href: "#ecosystem" },
  { label: "Study Abroad", href: "#programs" },
  { label: "India & Online", href: "#india" },
  { label: "Training", href: "#training" },
  { label: "Contact", href: "#contact" },
];

// ---- Lead form options ----
export const TRACKS = [
  "Study Abroad",
  "India Education — Offline",
  "India Education — Online",
];

export const PROGRAM_LEVELS = [
  "B.Tech / B.E.",
  "BBA",
  "BCA",
  "B.Sc",
  "B.Com / BA",
  "MBA / PGDM",
  "M.Tech / M.E.",
  "MCA",
  "M.Sc",
  "MA / M.Com",
  "Ph.D",
  "Diploma / Certificate",
];

export const COUNTRIES = [
  "Canada", "United States", "United Kingdom", "Australia",
  "Germany", "Ireland", "New Zealand", "France", "Singapore",
  "India", "Other",
];

export const COURSES = [
  "Computer Science / IT", "Data Science & AI", "Business & Management",
  "Engineering", "Healthcare & Nursing", "Aviation & Cabin Crew",
  "Finance & Accounting", "Business Analytics", "Design & Media",
  "Cybersecurity", "Psychology", "Other",
];

export const QUALIFICATIONS = [
  "Class 12 / Higher Secondary", "Diploma", "Bachelor's Degree",
  "Master's Degree", "Ph.D", "Working Professional",
];

export const INTAKE_YEARS = ["2026", "2027", "2028", "Not sure yet"];

// ---- Ecosystem / relationship ----
// ---- Institutional partners / franchise ----
export const ECOSYSTEM = [
  {
    name: "MSM Unify",
    role: "Global Platform Partner",
    href: "https://www.msmunify.com/",
    desc: "Our study-abroad backbone — the AI-powered platform connecting students to 1,500+ institutions, recruitment partners, employers and governments for overseas admissions and workforce development. Studyvia delivers its full suite of programs locally.",
    points: ["AI university matching", "Admissions & visa infrastructure", "Global institution network"],
  },
  {
    name: "Career Banale",
    role: "Career & Courses Partner",
    href: "https://careerbanale.com/",
    desc: "Our career and courses partner — study-abroad counselling, university pathway programs, test prep and career-focused online courses, all under one roof. Every Career Banale program is available through Studyvia.",
    points: ["Career counselling", "Test prep & pathways", "Online skilling courses"],
  },
];

// ---- Student journey ----
export const MANIFESTO = [
  { no: "01", title: "Explore", body: "AI-powered career discovery maps your strengths to the right degree, country and campus — no guesswork, only clarity rooted in data." },
  { no: "02", title: "Select", body: "From 1,500+ global universities and top Indian institutions, we shortlist the programs where you are most likely to thrive and get admitted." },
  { no: "03", title: "Apply", body: "Admissions, documentation, visas, scholarships and education loans — handled end-to-end by counsellors who know the process inside out." },
  { no: "04", title: "Thrive", body: "Test prep, upskilling courses, internships and employability support ensure your journey continues long after you enrol." },
];

// ---- Study abroad featured programs (from Career Banale) ----
export const ABROAD_PROGRAMS = [
  { name: "MS Business Analytics", level: "Master's", country: "USA", duration: "2 Years", fee: "USD 24,452" },
  { name: "Banking & Finance (BSc Hons)", level: "Bachelor's", country: "UK", duration: "3 Years", fee: "GBP 15,000" },
  { name: "BSc Psychology", level: "Bachelor's", country: "UK", duration: "4 Years", fee: "GBP 12,000" },
  { name: "Post Baccalaureate Diploma", level: "Diploma", country: "Canada", duration: "1 Year", fee: "CAD 26,426" },
  { name: "Mechanical Engineering MS", level: "Master's", country: "USA", duration: "2 Years", fee: "USD 50,564" },
];

// ---- India education degrees (online + offline) ----
export const INDIA_DEGREES = [
  { code: "B.Tech", name: "Bachelor of Technology", note: "4-year engineering across CSE, AI/ML, ECE & more." },
  { code: "MBA", name: "Master of Business Admin", note: "Full-time, executive & online MBA / PGDM." },
  { code: "M.Sc", name: "Master of Science", note: "Data Science, CS, Physics, Analytics & more." },
  { code: "BCA / MCA", name: "Computer Applications", note: "Industry-ready software & IT degrees." },
  { code: "BBA", name: "Bachelor of Business Admin", note: "Management foundations for future leaders." },
  { code: "Ph.D", name: "Doctoral Research", note: "Full & part-time research across disciplines." },
];

// ---- Online courses (from Career Banale) ----
export const ONLINE_COURSES = [
  { name: "Machine Learning with Python", duration: "3 Months", fee: "₹9,500" },
  { name: "Generative AI & Prompt Engineering", duration: "2 Months", fee: "₹7,000" },
  { name: "Full Stack Ruby on Rails", duration: "6 Months", fee: "₹15,000" },
  { name: "Excel & Power BI Analytics", duration: "2 Months", fee: "₹9,500" },
  { name: "Problem Solving & Analytical Skills", duration: "1.5 Months", fee: "₹6,000" },
];

export const TEST_PREP = ["IELTS", "TOEFL", "PTE", "GRE", "GMAT", "SAT"];

// ---- Services (unified platform) ----
export const SERVICES = [
  {
    title: "AI-Powered Student Counselling",
    desc: "A personalised guidance engine that recommends courses, countries and universities based on your profile and goals.",
    span: "lg:col-span-2 lg:row-span-2",
    image: "https://images.unsplash.com/photo-1674027444485-cec3da58eef4",
    tag: "Flagship",
  },
  { title: "University Pathways", desc: "Pathway & credit-transfer programs into top global universities.", span: "", tag: "Admissions" },
  { title: "Recruitment & CRM Platform", desc: "A unified platform connecting students, partners & institutions.", span: "", tag: "Platform" },
  { title: "Career & Employability", desc: "Internships, workshops and interview readiness for global careers.", span: "lg:col-span-2", tag: "Outcomes" },
];

export const STUDENT_SUPPORT = [
  "Education Loans", "Student Accommodation", "GIC Canada",
  "Virtual Internships", "Health Insurance", "Forex & Money Transfer",
];

export const TECH_DOMAINS = [
  "Artificial Intelligence", "Machine Learning", "Generative AI",
  "Big Data Analytics", "NLP", "AI Automation", "Cloud Computing",
  "Cybersecurity", "Data Science", "Software Development", "DevOps",
];

export const INDUSTRY_DOMAINS = [
  "Healthcare", "Aviation & Cabin Crew", "Finance", "Retail Banking",
  "Business Analytics", "Digital Transformation", "Leadership Development",
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  students: "https://images.pexels.com/photos/7683910/pexels-photo-7683910.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  corporate: "https://images.unsplash.com/photo-1758691736433-4078b93abd72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHw0fHxjb3Jwb3JhdGUlMjBidXNpbmVzcyUyMHRyYWluaW5nJTIwcHJlc2VudGF0aW9ufGVufDB8fHx8MTc4NDgxNTg5Nnww&ixlib=rb-4.1.0&q=85",
};

export const CORE_BUSINESS = [
  {
    no: "01",
    title: "Global Student Mobility",
    points: [
      "International student recruitment",
      "University admissions",
      "Career counselling",
      "Scholarships & financial aid",
      "Visa & immigration support",
      "Accommodation & pre-departure",
      "Test prep (IELTS, TOEFL, PTE & more)",
    ],
  },
  {
    no: "02",
    title: "Higher Education Solutions",
    points: [
      "Internationalization strategy",
      "Recruitment & enrollment growth",
      "Digital marketing & lead generation",
      "Academic partnerships",
      "Online & hybrid education enablement",
      "Global market expansion",
    ],
  },
  {
    no: "03",
    title: "Digital Learning & Academic Services",
    points: [
      "Online learning solutions",
      "Learning management support",
      "Academic content development",
      "Curriculum modernization",
    ],
  },
];

export const CONTACT = {
  city: "Bhubaneswar, Odisha",
  email: "info@studyvia.co.in",
  phone: "+91 77601 63344",
  address: "Deen Dayal Bhawan, Janpath, Bhubaneswar, Odisha",
  brand: "Studyvia Private Limited",
  tagline: "Guiding Dreams Beyond Borders",
};

export const FLORIDA_COASTAL = {
  name: "Florida Coastal University",
  role: "Exclusive Online Degree Partner",
  location: "USA",
  degrees: [
    { level: "Bachelor's", desc: "Online undergraduate programs across leading disciplines." },
    { level: "Master's", desc: "Accredited online master's degrees for career growth." },
    { level: "Doctorate", desc: "Online doctoral programs for research and leadership." },
  ],
};

export const STATS = [
  ["1,500+", "Global Universities"],
  ["30+", "Countries"],
  ["5M", "Learners by 2028"],
];
